import { Dashboard, DashboardParams } from '../types/api';

export type DashboardStorage = {
  dashboards: Dashboard[];
  updateDashboardSharing: (
    id: string,
    sharedWith: Array<{ id: string }>,
    existingUsers: string[]) => void;
  removeDashboard: (id: string) => void;
  loadDashboards: (params?: DashboardParams) => void;
  isLoading: boolean;
};

export enum DashboardOpenMode {
  edit, view, create
}